import { render, staticRenderFns } from "./SalidaInventarioFormComponent.vue?vue&type=template&id=22b4d466&"
import script from "./SalidaInventarioFormComponent.vue?vue&type=script&lang=js&"
export * from "./SalidaInventarioFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports